//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import orderCreatable from "~/mixins/orderCreateable.js";
export default {
  mixins: [orderCreatable],
  props: {
    selectCCorp: {
      required: false,
    },
    selectLLC: {
      required: false,
    },
    selectSCorp: {
      required: false,
    },
    selectNP: {
      required: false,
    },
  },
  data() {
    return {
      shouldShowDetails: {},
      tableData: [
        {
          type: "categ",
          title: "Protection",
        },
        {
          type: "row",
          title: "Limited Liability Protection",
          LLC: true,
          SCORP: true,
          CCORP: true,
          NONPROFIT: true,
          details: {
            LLC:
              "An LLC provides limited liability, meaning your personal assets are protected from any business liabilities.",
            SCORP:
              "An S corp provides limited liability, meaning your personal assets are protected from any business liabilities.",
            CCORP:
              "A C corp provides limited liability, meaning your personal assets are protected from any business liabilities.",
            NONPROFIT:
              "A nonprofit provides limited liability, meaning your personal assets are protected from any business liabilities.",
          },
        },
        {
          type: "categ",
          title: "Fees",
        },
        {
          type: "row",
          title: "Formation or Filling Fees",
          LLC: true,
          SCORP: true,
          CCORP: true,
          NONPROFIT: true,
          details: {
            LLC:
              "LLCs are subject to state formation or filing fees. Fees vary depending on the state.",
            SCORP:
              "S corps are subject to state formation or filing fees. Fees vary depending on the state.",
            CCORP:
              "C corps are subject to state formation or filing fees. Fees vary depending on the state.",
            NONPROFIT:
              "Nonprofits are subject to state formation or filing fees. Fees vary depending on the state.",
          },
        },
        {
          type: "row",
          title: "Ongoing Fees",
          LLC: true,
          SCORP: true,
          CCORP: true,
          NONPROFIT: true,
          details: {
            LLC:
              "LLCs may be required to pay annual or biennial fees and franchise tax depending on the state.",
            SCORP:
              "S corps may be required to pay annual or biennial fees and franchise tax depending on the state.",
            CCORP:
              "C corps may be required to pay annual or biennial fees and franchise tax depending on the state.",
            NONPROFIT: "Ongoing fees vary state by state.",
          },
        },
        {
          type: "categ",
          title: "Management",
        },
        {
          type: "row",
          title: "Management Flexibility",
          LLC: true,
          SCORP: false,
          CCORP: false,
          NONPROFIT: false,
          details: {
            LLC:
              "LLCs can be either member- or manager-managed depending on the terms of the operating agreement.",
            SCORP:
              "S corps are managed by directors who are elected by the shareholders in accordance with the corporation's bylaws.",
            CCORP:
              "C corps are managed by directors who are elected by the shareholders in accordance with the corporation's bylaws.",
            NONPROFIT:
              "Nonprofits are managed by a board of directors as set out in the corporate bylaws.",
          },
        },
        {
          type: "row",
          title: "Ownership Changes",
          LLC: true,
          SCORP: false,
          CCORP: false,
          NONPROFIT: null,
          details: {
            LLC:
              "LLC membership changes are governed by the operating agreement.",
            SCORP:
              "S corp ownership changes are transferred through the sale of shares.",
            CCORP:
              "C corp ownership changes are transferred through the sale of shares.",
            NONPROFIT:
              "Nonprofits do not issue stock and therefore do not have owners.",
          },
        },
        {
          type: "row",
          title: "Compliance",
          LLC: true,
          SCORP: true,
          CCORP: true,
          NONPROFIT: true,
          details: {
            LLC:
              "LLCs may be required to file an annual or biennial report and pay fees and franchise tax depending on the state.",
            SCORP:
              "S corps are required to follow all corporate requirements, such as holding annual meetings, maintaining corporate bylaws, and issuing stock, in addition to filing annual or biennial reports and paying fees and franchise tax.",
            CCORP:
              "C corps are required to follow all corporate requirements, such as holding annual meetings, maintaining corporate bylaws, and issuing stock, in addition to filing annual or biennial reports and paying fees and franchise tax.",
            NONPROFIT:
              "Nonprofits are required to follow all corporate requirements, such as holding annual meetings and maintaining corporate bylaws. Depending on the state, they may also be required to file an annual report. For federal tax exemptions, nonprofits are required to qualify and comply with IRS rules.",
          },
        },
        {
          type: "row",
          title: "Ease of Raising Capital",
          LLC: true,
          SCORP: true,
          CCORP: true,
          NONPROFIT: true,
          details: {
            LLC:
              "Even though LLCs do not have stock, LLCs are able to fundraise by selling equity and adding members or creating new membership interests in accordance with their operating agreement.",
            SCORP:
              "S corps are able to fundraise through the issuance and sales of stock, as long as the number of shareholders does not exceed 100 and no shareholder is a non-resident alien.",
            CCORP:
              "C corps are able to fundraise through the issuance and sales of stock.",
            NONPROFIT:
              "Nonprofits do not issue stock and therefore cannot raise funds through the sale of ownership rights. Instead, nonprofits may receive loans and accept charitable donations.",
          },
        },
        {
          type: "categ",
          title: "Tax",
        },
        {
          type: "row",
          title: "Pass-Through Entity ",
          LLC: true,
          SCORP: true,
          CCORP: false,
          NONPROFIT: false,
          details: {
            LLC:
              "LLCs are pass-through entities for tax purposes. All profits and losses are reported on the personal returns of the LLC members. LLCs are not taxed at the company level.",
            SCORP:
              "S corps can elect to be considered as pass-through entities for tax purposes. All profits and losses are reported on the personal returns of the S corp’s shareholders.",
            CCORP:
              "C corps are not eligible for pass-through taxation and must file their own returns.",
            NONPROFIT:
              "Nonprofits are not eligible for pass-through taxation as they do not have owners. Nonprofits must be taxed at the corporate level.",
          },
        },

        {
          type: "row",
          title: "Double Taxation",
          LLC: false,
          SCORP: false,
          CCORP: true,
          NONPROFIT: false,
          details: {
            LLC:
              "LLCs avoid double taxation and are not taxed at the entity level.",
            SCORP:
              "S corps avoid double taxation and are not taxed at the entity level.",
            CCORP:
              "C corp profits face double taxation, both at the entity level and at the personal level when dividends are paid.",
            NONPROFIT:
              "Upon filing for and being granted tax-exempt status, nonprofits will not be liable for income taxes, single or double.",
          },
        },
        {
          type: "row",
          title: "Tax Exempt",
          LLC: false,
          SCORP: false,
          CCORP: false,
          NONPROFIT: false,
          details: {
            LLC: "LLCs are not tax exempt.",
            SCORP: "S corps are not tax exempt.",
            CCORP: "C corps are not tax exempt.",
            NONPROFIT:
              "Upon filing for and being granted tax-exempt status, nonprofits will not be liable for income tax. If tax-exempt status is not obtained, normal C corp status will be applied.",
          },
        },
      ],
    };
  },
  methods: {
    showDetails(index) {
      if (!this.shouldShowDetails) this.shouldShowDetails = {};
      if (this.shouldShowDetails[index] === true)
        this.$set(this.shouldShowDetails, index, false);
      else this.$set(this.shouldShowDetails, index, true);
    },
  },
};
